// Footer: editorial, structured, calm
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-warm-white/95 text-primary border-t border-taupe-light/30">
      <div className="max-w-screen-xl mx-auto px-4">
        {/* Main Content */}
        <div className="py-16 grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Left Column - Info */}
          <div className="lg:col-span-7 space-y-12">
            {/* Brand */}
            <div>
              <img src="/logo-ottica-bellodi.svg" alt="Ottica Bellodi" width="192" height="48" className="h-12 w-auto mb-3" />
              <p className="text-base text-taupe max-w-md">
                Ottica di famiglia dal 1956
              </p>
            </div>

            {/* Contact & Hours */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {/* Contatti */}
              <div>
                <h4 className="font-sans font-medium text-xs uppercase tracking-[0.2em] mb-4 text-primary opacity-80">Contatti</h4>
                <ul className="space-y-3 text-base text-taupe">
                  <li>
                    <a href="mailto:info@otticabellodi.net" className="text-taupe no-underline hover:text-accent transition-colors flex items-center gap-3">
                      <svg className="w-5 h-5 flex-shrink-0 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      <span>info@otticabellodi.net</span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:011396871" className="text-taupe no-underline hover:text-accent transition-colors flex items-center gap-3">
                      <svg className="w-5 h-5 flex-shrink-0 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      <span>011 396871</span>
                    </a>
                  </li>
                  <li className="pt-2">
                    <a 
                      href="https://www.google.com/maps/place/Ottica+Bellodi+-+Ottico+Torino+Santa+Rita/@45.0366498,7.6439308,17z/data=!3m1!5s0x47881329cd73f71b:0xcd87a2d1b26b0b8c!4m15!1m8!3m7!1s0x4788132832d44731:0x2b4b0482bdd9ea5c!2sCorso+Giovanni+Agnelli,+104,+10137+Torino+TO!3b1!8m2!3d45.0366498!4d7.6439308!16s%2Fg%2F11q2nfj88_!3m5!1s0x4788132832cb31a9:0xd0ae8aee273560b4!8m2!3d45.0366773!4d7.6439152!16s%2Fg%2F1v2d_c_y?entry=ttu&g_ep=EgoyMDI2MDIxNi4wIKXMDSoASAFQAw%3D%3D" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-taupe no-underline hover:text-accent transition-colors flex items-start gap-3"
                    >
                      <svg className="w-5 h-5 flex-shrink-0 text-accent mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <span>C.so Giovanni Agnelli 104/B<br />Torino</span>
                    </a>
                  </li>
                  <li className="pt-2 text-sm font-medium text-accent">Gradita prenotazione</li>
                </ul>
              </div>

              {/* Orari */}
              <div>
                <h4 className="font-sans font-medium text-xs uppercase tracking-[0.2em] mb-4 text-primary opacity-80">Orari</h4>
                <ul className="space-y-3 text-base text-taupe">
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 flex-shrink-0 text-accent mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <span className="block text-taupe text-base mb-1 font-medium">Martedì – Sabato</span>
                      <span className="font-medium text-primary">09:00 – 12:30<br />15:30 – 19:30</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 flex-shrink-0 text-accent mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                    </svg>
                    <div>
                      <span className="block text-taupe text-base font-medium">Lunedì e Domenica</span>
                      <span className="font-medium text-primary">Chiuso</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right Column - Map */}
          <div className="lg:col-span-5">
            <h4 className="font-sans font-medium text-xs uppercase tracking-[0.2em] mb-4 text-primary opacity-80">Dove siamo</h4>
            <div className="rounded-lg overflow-hidden shadow-sm border border-taupe-light/30 h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2819.8445885894987!2d7.641751676536789!3d45.03667727107497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4788132832cb31a9%3A0xd0ae8aee273560b4!2sOttica%20Bellodi%20-%20Ottico%20Torino%20Santa%20Rita!5e0!3m2!1sit!2sit!4v1708270000000!5m2!1sit!2sit"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ottica Bellodi - Mappa"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-taupe-light/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-taupe">
            <p>
              © 2026 Ottica Bellodi - Torino
            </p>
            <div className="flex flex-wrap items-center gap-6">
              <span className="text-xs">P.IVA 07843470019</span>
              <Link to="/privacy/" className="hover:text-accent transition-colors">Privacy</Link>
              <Link to="/cookie/" className="hover:text-accent transition-colors">Cookie</Link>
              <a href="https://webeseo.it" target="_blank" rel="noopener noreferrer" className="text-xs text-taupe/60 hover:text-accent transition-colors no-underline">Powered by webeseo.it</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}